module.exports = __webpack_public_path__ + "static/media/120.cf20f6fd.jpg";